import * as React from 'react';
import { Dialog } from 'components/dialog';
import { SimpleSelect, SelectItem } from 'components/input/SimpleSelect';
import { Button } from '@material-ui/core';

// gapikey = AIzaSyAlUdS4buwLEjcnllXzWZBUnv4GOWWBbMA

export class GSMonthlyVacationExportDialog extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        var currentYear = new Date().getFullYear();
        var currentMonth = new Date().getMonth();

        this.state = {
            selectedYear: "" + currentYear,
            selectedMonth: "" + (currentMonth + 1)
        }

        this.handleYearChanged = this.handleYearChanged.bind(this);
        this.handleMonthChanged = this.handleMonthChanged.bind(this);
    }

    private handleYearChanged(newValue: string) {
        this.setState({selectedYear: newValue})
    }

    private handleMonthChanged(newValue: string) {
        this.setState({selectedMonth: newValue})
    }

    public render() {
        var currentYear = new Date().getFullYear();
        return (
            <Dialog title="Monthly vacation export (Google Spreadsheet)" desc="Fill the form below to export the vacation riport of all users." onFadeClicked={this.props.onCancelClicked}>
                <SimpleSelect label="Year" infoText="The year which you want to export" defaultValue={"" + this.state.selectedYear} onChange={this.handleYearChanged}>
                    <SelectItem title={"" + (currentYear)} value={"" + (currentYear)} />
                    <SelectItem title={"" + (currentYear - 1)} value={"" + (currentYear - 1)} />
                </SimpleSelect>

                <SimpleSelect label="Month" infoText="The month which you want to export" defaultValue={"" + this.state.selectedMonth} onChange={this.handleMonthChanged}>
                    <SelectItem title="January" value="1" />
                    <SelectItem title="February" value="2" />
                    <SelectItem title="March" value="3" />
                    <SelectItem title="April" value="4" />
                    <SelectItem title="May" value="5" />
                    <SelectItem title="Jun" value="6" />
                    <SelectItem title="July" value="7" />
                    <SelectItem title="August" value="8" />
                    <SelectItem title="Sepyember" value="9" />
                    <SelectItem title="October" value="10" />
                    <SelectItem title="November" value="11" />
                    <SelectItem title="December" value="12" />
                </SimpleSelect>

                <a href={"/export/monthlyVacationExportSS.jsp?y=" + this.state.selectedYear + "&m=" + this.state.selectedMonth} target="_blank">
                    <Button variant="contained">Export</Button>
                </a>
            </Dialog>
        );
    }
}

export class Props {

    public onCancelClicked?: { (): void };

}

interface State {

    selectedYear: string;
    selectedMonth: string;

}

